module.exports = __webpack_public_path__ + "img/home_adapt_vertical_add_normal.714ab311.svg";